<template>
    <div class="pref-mass-edit-input">
        <el-form :rules="pref.validator" :model="modelForm" class="mb-0">
            <el-form-item
                class="flex-column-content mb-0"
                :prop="pref.name"
                :error="error.get(pref.name)"
            >
                <p>{{ pref.label }}</p>
                <component
                    :is="pref.component"
                    v-if="pref.component !== ''"
                    v-bind="pref.data"
                    v-model="pref.value"
                    class="input-pref-mass-edit"
                ></component>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import SelectInput from 'vcomponents/inputs/SelectInput.vue';
import InputWithSelect from 'vcomponents/inputs/InputWithSelect.vue';
import Checkbox from 'vcomponents/inputs/custom/Checkbox.vue';
import PaydatesSelect from 'vcomponents/inputs/PaydatesSelect.vue';

export default {
    components: {
        SelectInput,
        InputWithSelect,
        Checkbox,
        PaydatesSelect,
    },
    props: {
        pref: {
            type: Object,
            required: true,
        },
        metas: {
            type: Object,
            required: true,
        },
        error: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    computed: {
        modelForm() {
            return {
                [this.pref.name]: this.pref.value.input,
            };
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.pref-mass-edit-input {
    .input-with-select .el-input-group__append {
        background-color: #fff;
    }

    .el-popper.el-cascader__dropdown {
        .el-cascader-panel {
            .el-scrollbar.el-cascader-menu .el-cascader-menu__wrap.el-scrollbar__wrap {
                color: $gray-100;
                width: 416px;
                min-height: 300px;
                .el-scrollbar__view.el-cascader-menu__list {
                    padding: 4px 0;
                    .el-cascader-node.is-active {
                        color: $gray-100;
                        font-weight: normal;
                    }
                }

                .el-cascader-node:hover {
                    background: #edf0ff;
                }
            }
        }
    }

    .el-cascader__tags {
        .el-tag.el-tag--info.el-tag--small.el-tag--light {
            color: $gray-60;
            font-weight: $font-weight-semibold;

            .el-tag__close.el-icon-close {
                background-color: #ccccd1;
            }
        }
    }

    .input-with-select.el-input.el-input-group {
        .el-input-group__append {
            width: 100px;
            color: $gray-60;
        }
    }
}
</style>
